const soil_nutrient_elements = [
  { element: "NO3-N", unit: "lbs/ac", class: ["border-left"] },
  { element: "P", unit: "lbs/ac" },
  { element: "K", unit: "lbs/ac" },
  { element: "SO4-S", unit: "lbs/ac", class: ["border-left"] },
  { element: "Ca", unit: "ppm" },
  { element: "Mg", unit: "ppm", class: ["border-right"] },
  { element: "Zn", unit: "ppm" },
  { element: "B", unit: "ppm" },
  { element: "Cu", unit: "ppm" },
  { element: "Fe", unit: "ppm" },
  { element: "Mn", unit: "ppm" },
  { element: "Na", unit: "ppm" },
  { element: "Cl", unit: "ppm" },
  { element: "Mo", unit: "ppm" },
  { element: "Al", unit: "ppm" },
];

const soil_nutrient_report_elements = [
  { element: "NO3-N", unit: "lbs/ac" },
  { element: "P", unit: "lbs/ac" },
  { element: "EC", unit: "dS/m" },
  { element: "pH", unit: null },
  { element: "OM", unit: "%" },
  { element: "K", unit: "lbs/ac" },
  { element: "SO4-S", unit: "lbs/ac" },
  { element: "Cu", unit: "ppm" },
  { element: "Zn", unit: "ppm" },
  { element: "B", unit: "ppm" },
  { element: "Mn", unit: "ppm" },
  { element: "Fe", unit: "ppm" },
  { element: "Ca", unit: "ppm" },
  { element: "Mg", unit: "ppm" },
  { element: "Na", unit: "ppm" },
  { element: "Cl", unit: "ppm" },
  { element: "ECEC", unit: null },
  { element: "Ca", unit: null },
  { element: "K", unit: null },
  { element: "Mg", unit: null },
  { element: "Na", unit: null },
  { element: "H", unit: null },
  { element: "Total", unit: null },
  { element: "Lime", unit: null },
  { element: "K/Mg", unit: "Ratio" },

];

const soil_nutrient_element_thresholds = [
  { element: "NO3-N", thresholds: [25, 50, 75, 100] },
  { element: "P", thresholds: [25, 50, 75, 100] },
  { element: "K", thresholds: [25, 50, 75, 100] },
  { element: "SO4-S", thresholds: [15, 30, 45, 60] },
  { element: "Ca", thresholds: [0, 0, 0, 0] },
  { element: "Mg", thresholds: [0, 0, 0, 0] },
  { element: "Zn", thresholds: [0, 0, 0, 0] },
  { element: "B", thresholds: [0, 0, 0, 0] },
  { element: "Cu", thresholds: [0, 0, 0, 0] },
  { element: "Fe", thresholds: [0, 0, 0, 0] },
  { element: "Mn", thresholds: [0, 0, 0, 0] },
  { element: "Na", thresholds: [0, 0, 0, 0] },
  { element: "Cl", thresholds: [0, 0, 0, 0] },
  { element: "Mo", thresholds: [0, 0, 0, 0] },
  { element: "Al", thresholds: [0, 0, 0, 0] },
];

const soil_characteristics = [
  { element: "OM", unit: "%" },
  { element: "Estimated N Release", unit: "lbs/ac" },
  { element: "pH", unit: null, ratio: "1:1" },
  { element: "Sol Salts", unit: "dS/m", ratio: "1:1" },
  { element: "Lime Req.", unit: "tonne/ha" },
  { element: "BS-Ca", unit: null },
  { element: "BS-K", unit: null },
  { element: "BS-Mg", unit: null },
  { element: "BS-Na", unit: null },
  { element: "BS-H", unit: null },
  { element: "BS-Total", unit: null },
  { element: "ECEC", unit: null },
  { element: "K/Mg Ratio", unit: null },
];

const soil_texture_characteristics = [
  { element: "Sand", unit: "%" },
  { element: "Silt", unit: "%" },
  { element: "Clay", unit: "%" },
  { element: "CEC", unit: "meq/100g" },
];

const recommendation_elements = [
  { element: "N", unit: "lbs/acre" },
  { element: "P2O5", unit: "lbs/acre" },
  { element: "K2O", unit: "lbs/acre" },
  { element: "S", unit: "lbs/acre" },
  { element: "Zn", unit: "lbs/acre" },
  { element: "B", unit: "lbs/acre" },
  { element: "Cu", unit: "lbs/acre" },
  { element: "Fe", unit: "lbs/acre" },
  { element: "Mn", unit: "lbs/acre" },
];

export {
  soil_nutrient_elements,
  soil_nutrient_element_thresholds,
  soil_nutrient_report_elements,
  soil_characteristics,
  soil_texture_characteristics,
  recommendation_elements
};
